import { EExportType } from "@rentiohq/shared-frontend/dist/reduxV2/exportFile";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { MultiStepForm } from "@rentiohq/web-shared/dist/components";
import createCustomExportSchemas from "forms/createCustomExport";
import {
  isPerformingSubmitActionSelector,
  performingSubmitActionErrorSelector,
  performingSubmitActionResultSelector,
  resetSubmitTarget,
  submitActionCreator,
} from "forms/createCustomExport/schema.createCustomExport.actions";
import React from "react";

interface IProps {
  exportTypes: EExportType[];
  isRecurring?: boolean;
  canSchedule: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export const CreateCustomExportModal = (props: IProps) => {
  const {
    exportTypes,
    isRecurring = false,
    canSchedule,
    onClose,
    onSuccess,
  } = props;

  // Before the first render, so the selectors never read a previous submit's result.
  React.useState(() => {
    resetSubmitTarget();
    return true;
  });

  return (
    <MultiStepForm
      formId={"create-custom-export"}
      schemas={createCustomExportSchemas({
        exportTypes,
        isRecurring,
        canSchedule,
      })}
      asModal={true}
      withAside={false}
      modalProps={{ onClose, shouldCloseOnOverlayClick: true, width: "medium" }}
      onSuccess={onSuccess}
      isPerformingSubmitActionSelector={isPerformingSubmitActionSelector}
      performingSubmitActionResultSelector={
        performingSubmitActionResultSelector
      }
      performingSubmitActionErrorSelector={performingSubmitActionErrorSelector}
      submitActionCreator={submitActionCreator()}
      submitLabel={getLocalizedText("system.export")}
    />
  );
};
